import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CreateCloudAccountDialogData,
  CreateCloudAccountRequest,
  CreateCloudAccountResponse,
  ErmDevOpsApiClientService
} from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent {

  isSaving: boolean = false;
  createCloudAccountRequest: CreateCloudAccountRequest;
  createCloudAccountResponse?: CreateCloudAccountResponse;

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public createCloudAccountDialogData: CreateCloudAccountDialogData,
    public dialogRef: MatDialogRef<CreateAccountComponent>) {
    this.createCloudAccountRequest = {
      customerId: createCloudAccountDialogData.customerId
    } as CreateCloudAccountRequest;
  }

  async save(): Promise<void> {
    try {
      this.isSaving = true;
      const createCloudAccountResponse = await this.ermDevOpsApiClient.createCloudAccount(this.createCloudAccountRequest);
      this.createCloudAccountResponse = createCloudAccountResponse.body as CreateCloudAccountResponse;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    this.dialogRef.close({ data: this.createCloudAccountResponse });
  }
}
